var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: { rules: "", name: "Peça Tecnica/Geometria" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c(
                  "keep-alive",
                  [
                    _c("pecaTecnica", {
                      attrs: { cadastroColetivo: _vm.copiaCadastroColetivo },
                      on: {
                        onRemoveGeometria: _vm.onRemoveGeometria,
                        atualizarPecaTecnica: _vm.atualizarPecaTecnica,
                        validacaoDocumentos: _vm.validacaoDocumentos
                      }
                    })
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _c(
        "div",
        [
          _vm.despachosFormatados.length
            ? _c("div", { staticClass: "wrap-collabsible" })
            : _vm._e(),
          _vm.despachosFormatados.length
            ? _c("divider", { attrs: { label: "Histórico de despachos" } })
            : _vm._e(),
          _c(
            "el-collapse",
            _vm._l(_vm.despachosFormatados, function(despacho) {
              return _c(
                "el-collapse-item",
                {
                  key: despacho.dataCriacao,
                  attrs: {
                    title: "Análise " + despacho.setor,
                    name: despacho.dataCriacao
                  }
                },
                [
                  _c("Informacoes-analise", {
                    attrs: {
                      responsavel: despacho.usuario.pessoa.nomeRazaoSocial,
                      cargo: despacho.perfil,
                      data: despacho.dataCriacao
                    }
                  }),
                  _c(
                    "div",
                    [
                      _c("divider", { attrs: { label: "Despacho" } }),
                      _c("div", { staticClass: "mt-1 padding-info-analise" }),
                      _c("el-row", [
                        _c("p", {
                          staticClass: "input",
                          domProps: { innerHTML: _vm._s(despacho.texto) }
                        })
                      ])
                    ],
                    1
                  ),
                  despacho.documento
                    ? _c(
                        "div",
                        [
                          _c("divider", { attrs: { label: "Anexo" } }),
                          despacho.documento
                            ? _c(
                                "div",
                                { staticClass: "arquivos" },
                                [
                                  _c("app-download-arquivo", {
                                    attrs: { arquivo: despacho.documento },
                                    on: {
                                      download: function($event) {
                                        return _vm.download(despacho.documento)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df9cd81e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df9cd81e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/components/ValidacaoEdicaoCadastro.vue
// module id = null
// module chunks = 